import { BaseAPIState, Value } from '@philips-emr/tws-core';
import { EventData, EventListener } from '@philips-emr/tws-core/lib/component/event';
import { Mountable } from '@philips-emr/tws-core/lib/component/types';

export enum Layout {
  SIMPLE = 'Simple',
  CARD = 'Card',
}

export interface PropCustom extends BaseAPIState {
  endpoint: string;
  data: Record<string, Value>;
  parameters: Record<string, Value>;
  hasTitleAction: boolean;
}

export interface ParamAction {
  endpoint?: string;
  parameters?: Record<string, Value>;
}

export class HpmsCustomContentCollapseArgs<T> {
  onOpenRender: ActionRenderType;
  data: T;
}

export type ActionRenderType = (event: ParamAction) => void;

export class HpmsCustomContentCollapseEvent<T> extends EventData<HpmsCustomContentCollapseEventType<T>> implements HpmsCustomContentCollapseArgs<T> {
  data: T;
  onOpenRender: ActionRenderType;

  constructor({ data, onOpenRender }: HpmsCustomContentCollapseArgs<T>) {
    super();

    this.data = data;
    this.onOpenRender = onOpenRender;
  }
}

export default interface HpmsCustomContentCollapseEventType<T> extends Mountable {

  /** @event */
  onOpen: HpmsCustomContentCollapseEventListener<T>;

}

export class HpmsCustomContentCollapseEventListener<T> extends EventListener<HpmsCustomContentCollapseEventType<T>, HpmsCustomContentCollapseEvent<T>, HpmsCustomContentCollapseArgs<T>> {
  constructor() {
    super(HpmsCustomContentCollapseEvent);
  }
}
